import styled from 'styled-components';

import uploadBg from '~/assets/img/upload-bg.png';

export const Container = styled.div`
  padding: 20px 0;
`;

export const BoxUploadLogo = styled.div`
  height: 249px;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid #eee;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  div.BoxUploadLogoBox {
    width: 100%;
    height: 249px;
    position: relative;
  }

  img {
    width: 280px;
    margin-left: 60px;
    height: auto;
    max-height: 200px;
    object-fit: contain;
    position: absolute;
  }

  label {
    width: 280px;
    height: 40px;

    position: absolute;
    top: 155px;
    left: 60px;
    cursor: pointer;
    z-index: 2;
    input {
      display: none;
    }
  }

  span.fileUploadText {
    font-size: 15px;
    font-weight: normal;
    line-height: 1.13;
    letter-spacing: 0.01px;
    text-align: center;
    color: #6c6c6c;
    display: block;
    position: absolute;
    bottom: 20px;
    margin: 0 30px;
  }
  button {
    top: 50px;
    z-index: 1;
  }
`;

export const BoxUpload = styled.div`
  width: 360px;
  height: 249px;
  margin: 0 auto;
  border-radius: 8px;
  border: 1px solid #eee;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;

  .formContainer {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;

    width: 360px;
    height: 240px;

    span.fileUploadText {
      font-size: 15px;
      font-weight: normal;
      line-height: 1.13;
      letter-spacing: 0.01px;
      text-align: center;
      color: #6c6c6c;
      display: block;
      position: relative;
      top: 20px;
      margin: 0 30px;
    }
    img {
      border: 1px solid blue;
      width: 200px;
      height: auto;

      align-self: center;
      position: absolute;
      z-index: 30;
    }

    label {
      border: 1px solid blue;
      width: 359px;
      height: 240px;

      background-image: url(${uploadBg});
      background-repeat: no-repeat;
      background-position: center 20px;
      cursor: pointer;
      position: absolute;
      color: #ffffff;
      border: none;
      z-index: 9999;
    }

    input {
      display: none;
    }
  }
`;

export const BoxSendButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 110px;
  z-index: 1;
  button {
    padding: 0 10px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
    position: absolute;
    bottom: 30px;
  }
`;
